import React from 'react'
import { shareRewardsActive } from 'lib/shareRewardsProgram'
import styles from './share-to-earn-label.module.scss'

// The share button's label on the daily shareable embeds (the report
// embeds and the daily-earnings card). Promises the per-view reward only
// while the program is paying this user; otherwise the surface's own label.
export default function ShareToEarnLabel({ fallback }: { fallback: React.ReactNode }) {
    if (!shareRewardsActive()) return <span>{fallback}</span>

    return (
        <span className={styles.label} data-testid="share-to-earn-label">
            Share to Earn 1¢ per view
        </span>
    )
}
